<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="perguntas.content"
      class="mt-8"
      :loading="loading"
      :server-items-length="perguntas.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhuma pergunta encontrada"
      loading-text="Carregando perguntas..."
      :options="optionsList"
    >
      <template v-slot:item.oferta.titulo="{ item }">
        {{ item.oferta.titulo | truncate(40) }}
      </template>
      <template v-slot:item.horarioPergunta="{ item }">
        {{ item.horarioPergunta | date(true) }}
      </template>
      <template v-slot:item.options="{ item }">
        <v-btn icon
               link
               :to="link(item)">
          <v-icon>mdi-comment-question</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    perguntas: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Oferta',
          value: 'oferta.titulo',
        },
        {
          text: 'Horário',
          value: 'horarioPergunta',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {
    link() {
      return (item) => `/marketplace/ofertas/${item.oferta.id}`;
    },
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    emitUpdate() {
      this.$emit('update');
    },
  },
};
</script>
